export default function clearSpaces(value: string): string {
  const cleanValue = value?.trim();
  return cleanValue?.replace(/\s{2,}/g, ' ') ?? '';
}
